import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../services/user.service';
import { Modal } from '../../services/modal.service';

@Component({
  selector: 'modal-password-reset',
  imports: [TranslatePipe, FormsModule, ReactiveFormsModule],
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  private modal = inject(Modal);
  private fb = inject(FormBuilder);
  private spinner = inject(NgxSpinnerService);
  private userService = inject(UserService);
  private translate = inject(TranslateService);

  error = signal<string>('');
  success = signal<boolean>(false);
  resetForm!: FormGroup;

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  close() {
    this.modal.dismiss();
  }

  resetPassword() {
    this.spinner.show();
    const email: string = this.resetForm.value.email;
    this.userService.resetPassword(email).subscribe({
      next: _ => {
        this.spinner.hide();
        this.success.set(true);
      },
      error: _ => {
        this.spinner.hide();
        this.error.set(this.translate.instant('message_incorrect_email'));
      }
    });
  }
}